import { withApiKey, withPublic } from '@/app/helpers/auth.context';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ComplaintRequest {
  complaintType: number;
  description: string;
  incidentDate: string;
  department: number;
  complaintFile?: File | null;
  isAnonymous: boolean;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
}

export interface ComplaintResponse {
  id: number;
  complaintTypeId: number;
  description: string;
  incidentDate: string;
  departmentId: number;
  complaintFile: string;
  isAnonymous: boolean;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  complaintType: {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string;
  };
  department: {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ComplaintService {
  constructor(private http: HttpClient) {}

  createComplaint(complaintRequest: ComplaintRequest): Observable<ComplaintResponse> {
    const formData = new FormData();

    // Iterate over the keys of the request and append them to FormData
    Object.keys(complaintRequest).forEach((key) => {
      const value = (complaintRequest as any)[key];
      if (value !== null && value !== undefined) {
        if (key === 'complaintFile' && value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, value.toString());
        }
      }
    });

    return this.http.post<ComplaintResponse>('/complaint', formData, {
      context: withApiKey(),
    });
  }
}
